import request from '@/utils/request'

const VUE_APP_BASIC_DATA_API = process.env.VUE_APP_BASIC_DATA_API_C
// const VUE_APP_BASIC_DATA_API = 'http://10.166.2.23:3000/mock/36/'

/**
* 实名记录查询
*/
export function rnrInfo(data) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}rnr/rnrInfo`,
    method: 'post',
    data
  })
}

/**
* 获取解绑短信验证码
*/
export function unboundSms(data) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}rnr/unboundSms`,
    method: 'post',
    data
  })
}

/**
* 实名解绑
*/
export function unbound(data) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}rnr/unbound`,
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/bind.js